interface ACheckboxProps {
    checked: boolean;
    /** Parte da seleção marcada: expõe o estado misto e vence o `checked`. */
    indeterminate?: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    size?: 'sm' | 'md';
    /** Nome acessível do checkbox, quando o texto ao lado não é um <label> dele. */
    ariaLabel?: string;
}

const ACheckbox = ({ checked, indeterminate = false, onChange, disabled = false, size = 'sm', ariaLabel }: ACheckboxProps) => {
    const sizeClass = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
    return (
        <button
            type="button"
            role="checkbox"
            aria-checked={indeterminate ? 'mixed' : checked}
            aria-label={ariaLabel}
            disabled={disabled}
            onClick={() => !disabled && onChange(!checked)}
            className={`${sizeClass} rounded border-2 flex items-center justify-center transition-colors ${
                checked || indeterminate
                    ? 'bg-blue-600 border-blue-600 text-white'
                    : 'bg-white dark:bg-slate-700 border-gray-300 dark:border-slate-500 hover:border-blue-400'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
            {indeterminate ? (
                <svg className={size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3'} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 12h12" />
                </svg>
            ) : checked && (
                <svg className={size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3'} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
            )}
        </button>
    );
};

export default ACheckbox;
